import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { UserLayout } from 'components/layout/UserLayout'
import { GoogleMap, ShareLink } from '@marketing-milk/frontend'
import { ListPageBar } from 'components/layout/PageBar'
import { FullPageContent } from 'components/layout/FullPageLayout/Content/FullPageContent'
import { useLocalCompetitionFinder, CompetitionFinderMapTools, CompetitionList } from './'

export function LocalCompetition() {
  const finder = useLocalCompetitionFinder(false)
  const matches = useMediaQuery('(max-width:900px)')
  return (
    <UserLayout>
      <ListPageBar
        subject="Local Competition"
        actions={<ShareLink onlyIcon={false} url={finder.queryStringManager.stringifiedURL} />}
      />
      <FullPageContent className="flex">
        {finder.hasBusinessData && !matches && <CompetitionList {...finder} />}
        <div className="w-full h-full">
          <div className="w-full h-full relative">
            <GoogleMap
              center={finder.businessCoordinates}
              zoom={12}
              mapContainerStyle={{ width: '100%', height: '100%', minHeight: 400 }}
            >
              <CompetitionFinderMapTools {...finder} />
            </GoogleMap>
          </div>
        </div>
      </FullPageContent>
    </UserLayout>
  )
}
